/**
 * A promise together with its resolve/reject handles.
 *
 * Stands in for `$q.defer()` in code that no longer injects angular's `$q`.
 * Reach for it only when the settling happens somewhere the promise executor
 * cannot see - a callback handed to a popup, a recursive call. Otherwise plain
 * `new Promise(...)` / async-await reads better.
 */
export function createDeferred () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return {promise, resolve, reject};
}

export default createDeferred;
